export const locale = {
    lang: "es-ES",
    data: {
        PRIVACY_POLICE: {
            TITLE: "Política de privacidad",
            DEFAULT: "Política de privacidad no definidos.",
            SUBMIT_ERROR: "Error al recuperar la política de privacidad.",
            BUTTON_LABEL: "Cerrar"
        }
    }
};
